import { IsEmail } from 'class-validator';

import PasswordValidator from './PasswordValidator';
import { ERROR_MESSAGE } from './constants';

class EmailPasswordValidator extends PasswordValidator {
  @IsEmail({}, { message: ERROR_MESSAGE.INVALID_EMAIL })
  email: string;
}

export default EmailPasswordValidator;
